export enum APINewsArticleType {
  FRAUD = "Fraud",
  LEGAL = "Legal",
  BANKRUPTCY = "Bankruptcy",
}
